import api from "./index";

export const workersAPI = {
  getAll: (params) => api.get("/workers", { params }),
  getById: (id) => api.get(`/workers/${id}`),
  create: (data) => api.post("/workers", data),
  update: (id, data) => api.put(`/workers/${id}`, data),
  delete: (id) => api.delete(`/workers/${id}`),
  getTimesheet: (id, params) => api.get(`/workers/${id}/timesheet`, { params }),
  getAvailable: (params) => api.get("/workers/available", { params }),
};
